@if (isLoading) {
  <div class="task-details__loader">
    <app-spinner />
  </div>
} @else if (hasCentralisationData) {
  <app-stepper class="d-block" [steps]="flowSteps" />
}
